export const GUANGZHOU_TIANHE_REGION_CODES = ['440000', '440100', '440106'] as const

export const MUNICIPALITY_CODES = new Set(['110000', '120000', '310000', '500000'])
